// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_ar-0";
export var optionCard = "_ar-1";